module.exports = __webpack_public_path__ + "static/media/bikes.e9d8766d.gif";